import _styled from "styled-components";
/* istanbul ignore file */

import React from 'react';
import { getNothsBlackLogoUrl, getNothsLogoUrl, getStaticFilesEnv } from '@noths/polaris-client-static-files';
import * as styles from "./SiteLogo.styles";
var isClockBetweenDates = function isClockBetweenDates(start, end) {
  var now = new Date();
  var timezoneOffset = now.getTimezoneOffset() * 60000;
  var currentTime = now.getTime() - timezoneOffset;
  var startTime = new Date(start).getTime();
  var endTime = new Date(end).getTime();
  return currentTime >= startTime && currentTime <= endTime;
};
export var SiteLogo = function SiteLogo(_ref) {
  var _ref$env = _ref.env,
    env = _ref$env === void 0 ? 'production' : _ref$env;
  var staticFilesEnv = getStaticFilesEnv(env);
  var blackFridaySale = isClockBetweenDates('2023-11-14T00:01:00.000Z', '2023-11-28T23:59:00.000Z');
  var logoUrl = blackFridaySale ? getNothsBlackLogoUrl(staticFilesEnv, '3001') : getNothsLogoUrl(staticFilesEnv, '3001');
  return /*#__PURE__*/React.createElement(_StyledImg, {
    alt: "",
    src: logoUrl,
    $_css: styles.image
  });
};
var _StyledImg = /*#__PURE__*/_styled("img").withConfig({
  displayName: "SiteLogo___StyledImg",
  componentId: "sc-fkaywe-0"
})(["", ""], function (p) {
  return p.$_css;
});